const getParam = (queryString, param) => {
  const name = param.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
  const regex = new RegExp(`[\\?&]${name}=([^&#]*)`);
  const results = regex.exec(queryString);
  if (results === null) {
    return null;
  }
  return decodeURIComponent(results[1].replace(/\+/g, ' '));
};

export default getParam;



// WEBPACK FOOTER //
// ../src/utils/getParam.js